import {
  ChangeDetectorRef,
  Component,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { StateService } from "./services/state.service";
import { NotificationService } from "./services/notification/notification.service";
import {
  cleanPanelFilters,
  decodeToken,
  getFormatedCountByStatus,
  isNotAuthorizationExpiryError,
} from "./util/common.util";
import { FilterService } from "./services/filter.service";
import { Filter, SavedFilter } from "./models/filter.model";
import { INotification } from "./models/notification.model";
import { MessageService } from "primeng/api";
import { NotificationDetailComponent } from "./notification/components/notification-detail/notification-detail.component";
import {
  catchError,
  Observable,
  of,
  Subject,
  Subscription,
  switchMap,
  take,
} from "rxjs";
import { ActivityService } from "./services/activity.service";
import {
  CHECK_NOTIFICATION_LIST_UPDATED_CALL_INTERVAL,
  EXPIRED_TOKEN_ERROR_MESSAGE,
  MISSING_AUTHORIZATION_ERROR_MESSAGE,
  EMAIL_FREQUENCY_VALUES,
  USER_ACTIVITY_MESSAGE_INTERVAL,
} from "./constants/common.constants";
import { filterKeys } from "./constants/filters.constants";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { Panel } from "./models/user.model";
import { NotificationListComponent } from "./notification/components/notification-list/notification-list.component";
import { NgForm, NgModel } from "@angular/forms";
import {
  clearFrequencyInputFieldErrors,
  formatTimeTwentyFourHour,
  getTotalPages,
  raiseInvalidFrequencyFlag,
  setFrequencyInputFieldErrors,
  setFrequencyTime,
  setFrequencyValues,
  validateFrequencyValue,
} from "./app.helper";
import { IPanel } from "./util/common.models";
import { NotificationSharedService } from "./notification/notifications-shared.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent {
  private inactivitySubscription: Subscription = new Subscription();
  private activitySubscription: Subscription = new Subscription();
  private searchNotificationsInSelectedPanel = new Subject<{
    panels: string[];
    tab: string;
    currentPage: number;
    rowsPerPage: number;
    sortBy: string;
    hasComments: boolean;
    hasUnread: boolean;
    currentSort: string;
    filters: Filter[];
  }>();

  isNotificationListUpdated: boolean = false;
  checkNotificationUpdatedInterval: any = null;
  selectedNotifications: string[] = [];
  currentPageSettings = {};
  selectAllNotificationsForMultiSelect: boolean = false;
  appliedFilter: SavedFilter | null = null;
  defaultFilterId: number | null = null;
  activeNotification: any;
  showDefaultPage: boolean = false;
  private multiSelectFlagUpdateSubscription: Subscription | undefined;
  fifteenMinutesFrequency = EMAIL_FREQUENCY_VALUES.fifteenMinutes;
  everyHourTwentyFourHourFrequency =
    EMAIL_FREQUENCY_VALUES.everyHourTwentyFourHour;
  everyHourOfficeHourFrequency = EMAIL_FREQUENCY_VALUES.everyHourOfficeHour;
  onceADayFrequency = EMAIL_FREQUENCY_VALUES.onceADay;
  twiceADayFrequency = EMAIL_FREQUENCY_VALUES.twiceADay;
  threeTimesADayFrequency = EMAIL_FREQUENCY_VALUES.threeTimesADay;
  selectedFrequency: string = this.fifteenMinutesFrequency;
  private selectedPanelsUpdateSubscription: Subscription | undefined;

  constructor(
    private readonly state: StateService,
    private readonly notificationService: NotificationService,
    private readonly filterService: FilterService,
    private readonly cdr: ChangeDetectorRef,
    private readonly messageService: MessageService,
    private readonly activityService: ActivityService,
    private breakpointObserver: BreakpointObserver,
    private notificationSharedService: NotificationSharedService
  ) {
    this.searchNotificationsInSelectedPanel
      .pipe(
        switchMap(() => {
          return this.notificationService
            .getNotifications(this.getNotificationPayload())
            .pipe(
              catchError((error: any) => {
                this.isLoadingNotifications = false;
                return [];
              })
            );
        })
      )
      .subscribe((notifications: any) => {
        if (
          notifications.notificationComments &&
          notifications.notificationComments.length > 0
        ) {
          notifications.data = this.setComments(
            notifications.data,
            notifications.notificationComments
          );
        }
        this.state.setNotifications(notifications.data);
        this.state.setNotificationCountByStatus(
          getFormatedCountByStatus(notifications.metaData)
        );
        this.notificationCountByStatus =
          this.state.getNotificationCountByStatus();
        this.totalNotifications =
          notifications?.metaData?.totalFilteredCount || 0;
        this.notificationsinList = notifications?.data?.length || 0;
        this.notifications = notifications.data;
        this.isLoadingNotifications = false;
        this.isNotificationListUpdated = false;
        this.checkIfSelectedNotificationIsPresentInList(notifications);
        if (this.selectAllNotificationsForMultiSelect) {
          const notificationIds = this.notifications.map((notification) => {
            return notification.id;
          });

          this.selectedNotifications = [
            ...new Set([...this.selectedNotifications, ...notificationIds]),
          ];
        }
      });
  }
  @ViewChild("alertFrequencyForm") alertFrequencyForm!: NgForm;
  @ViewChild("onceADayInput", { static: false }) onceADayInput!: NgModel;
  @ViewChild("twiceADayOne", { static: false }) twiceADayOne!: NgModel;
  @ViewChild("twiceADayTwo", { static: false }) twiceADayTwo!: NgModel;
  @ViewChild("threeTimesADayOne", { static: false })
  threeTimesADayOne!: NgModel;
  @ViewChild("threeTimesADayTwo", { static: false })
  threeTimesADayTwo!: NgModel;
  @ViewChild("threeTimesADayThree", { static: false })
  threeTimesADayThree!: NgModel;

  @ViewChild(NotificationDetailComponent)
  notificationDetailComponent!: NotificationDetailComponent;

  @ViewChild(NotificationListComponent)
  notificationListComponent!: NotificationListComponent;

  title(title: any) {
    throw new Error("Method not implemented.");
  }
  headerData: any;
  first: number = 0;
  rows: unknown;
  covidtest: any[""];
  sidebarVisible2: any;
  selectedTab: string = "all";
  sortBy: string = "";
  currentSort: string = "";
  panelSelectionPlaceholder: string = "Please select a panel";
  hasComments: boolean = false;
  hasUnread: boolean = false;
  appliedFilters: Filter[] = [];
  allEmailSubscribed: any = false;
  customEmailSubscribed: boolean = false;
  isLoadingSettings: boolean = false;
  isSavingSettings: boolean = false;
  isLoadingNotifications: boolean = false;
  search: string = "";
  onceADayTimeInput: any = "";
  twiceADayInputOne: any = "";
  twiceADayInputTwo: any = "";
  threeTimesADayInputOne: any = "";
  threeTimesADayInputTwo: any = "";
  threeTimesADayInputThree: any = "";

  errorOnceADayInput: boolean = false;
  errorTwiceADayInputOne: boolean = false;
  errorTwiceADayInputTwo: boolean = false;
  errorThreeTimesADayInputOne: boolean = false;
  errorThreeTimesADayInputTwo: boolean = false;
  errorThreeTimesADayInputThree: boolean = false;

  // Custome Pagination attributes
  totalItems = 120;
  rowsPerPage = 10;
  currentPage = 1;
  //
  notificationCountByStatus: any = {};
  panels: IPanel[] = [];
  notifications: any[] = [];
  selectedNotification: any;
  totalNotifications: number = 0;
  notificationsinList: number = 0;
  appliedFilterCount: number = 0;
  customEmailOptions: any[] = [];
  userActivityInterval: any;
  lastActivityTime: any = new Date();
  isMobile$: Observable<any> = of(null);

  public selectedPanels: any[] = [];
  public selectedPanelsTemp: any[] = [];

  // Handle the pagination change event
  onPageChange(event: any) {
    this.currentPage = event.currentPage;
    this.rowsPerPage = event.rowsPerPage;
    this.getNotificationsCall();
  }
  onPanelChange(event: any) {
    if (event.value.length > 1) {
      this.panelSelectionPlaceholder = "Please select a panel";
    }
    this.currentPage = 1;
    this.getNotificationsCall();
  }
  ngOnInit() {
    window.addEventListener("message", (event) => this.handleMessage(event));
    this.activitySubscription = this.activityService
      .onActivity()
      .subscribe(() => {
        this.lastActivityTime = new Date();
      });

    this.inactivitySubscription = this.activityService
      .monitorInactivity(USER_ACTIVITY_MESSAGE_INTERVAL)
      .subscribe();

    this.checkNotificationUpdatedInterval = setInterval(() => {
      if (this.panels?.length > 0) {
        this.notificationService.getNotificationHasUpdates().subscribe({
          next: (res) => {
            if (!res.success) {
              return;
            }
            this.isNotificationListUpdated = res.hasUpdates;
          },
          error: (err) => {},
        });
      }
    }, CHECK_NOTIFICATION_LIST_UPDATED_CALL_INTERVAL);
    this.isMobile$ = this.breakpointObserver.observe([Breakpoints.Handset]);

    this.selectedPanelsUpdateSubscription =
      this.notificationSharedService.setSelectedPanelsSubjectTriggerAction$.subscribe(
        (selectedPanels) => {
          if (this.panels?.length > 0) {
            this.selectedPanels = selectedPanels;
          } else {
            this.selectedPanelsTemp = selectedPanels;
          }
        }
      );
  }
  ngOnDestroy(): void {
    clearInterval(this.userActivityInterval);
    this.userActivityInterval = null;
    window.removeEventListener("message", () => console.log("cleanup"));

    if (this.inactivitySubscription) {
      this.inactivitySubscription.unsubscribe();
    }
    if (this.activitySubscription) {
      this.activitySubscription.unsubscribe();
    }
    this.activityService.stopMonitoring();
    clearInterval(this.checkNotificationUpdatedInterval);
    this.checkNotificationUpdatedInterval = null;
    this.multiSelectFlagUpdateSubscription?.unsubscribe();
    this.selectedPanelsUpdateSubscription?.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["panels"]) {
      const savedFilters = this.state.getSavedFilters();
      if (savedFilters?.length) {
        this.state.setSavedFilters(
          savedFilters.map((filter) => ({
            ...filter,
            filterValues: cleanPanelFilters(filter.filterValues, this.panels),
          }))
        );
      }
    }
  }

  getEmailSettingsCall() {
    this.isLoadingSettings = true;
    this.notificationService.getUserSettings().subscribe({
      next: (res) => {
        this.selectedFrequency = res.email_frequency;
        this.setFrequencyInputFields(res);

        this.allEmailSubscribed = res.emails_enabled;
        this.customEmailSubscribed = res.is_customized;

        this.customEmailOptions = this.state
          .getSavedFilters()
          ?.map((option) => {
            if (
              res.setting_filters?.find(
                (setting: { filter: { id: any } }) =>
                  setting.filter?.id === option.id
              )
            ) {
              return { label: option.name, value: option.id, checked: true };
            }
            return { label: option.name, value: option.id, checked: false };
          });
        this.isLoadingSettings = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.isLoadingSettings = false;
      },
    });
  }
  setFrequencyInputFields(res: any) {
    if (this.selectedFrequency == EMAIL_FREQUENCY_VALUES.onceADay) {
      if (!res?.frequency_times[0]) {
        this.selectedFrequency = EMAIL_FREQUENCY_VALUES.fifteenMinutes;
        return;
      }

      this.frequencyFields.onceADayTimeInput = res?.frequency_times[0];
      this.onceADayTimeInput = setFrequencyTime(res?.frequency_times[0]);
    } else if (this.selectedFrequency == EMAIL_FREQUENCY_VALUES.twiceADay) {
      if (!res?.frequency_times[0] || !res?.frequency_times[1]) {
        this.selectedFrequency = EMAIL_FREQUENCY_VALUES.fifteenMinutes;
        return;
      }

      this.frequencyFields.twiceADayInputOne = res?.frequency_times[0];
      this.frequencyFields.twiceADayInputTwo = res?.frequency_times[1];
      this.twiceADayInputOne = setFrequencyTime(res?.frequency_times[0]);
      this.twiceADayInputTwo = setFrequencyTime(res?.frequency_times[1]);
    } else if (
      this.selectedFrequency == EMAIL_FREQUENCY_VALUES.threeTimesADay
    ) {
      if (
        !res?.frequency_times[0] ||
        !res?.frequency_times[1] ||
        !res?.frequency_times[2]
      ) {
        this.selectedFrequency = EMAIL_FREQUENCY_VALUES.fifteenMinutes;
        return;
      }

      this.frequencyFields.threeTimesADayInputOne = res?.frequency_times[0];
      this.frequencyFields.threeTimesADayInputTwo = res?.frequency_times[1];
      this.frequencyFields.threeTimesADayInputThree = res?.frequency_times[2];
      this.threeTimesADayInputOne = setFrequencyTime(res?.frequency_times[0]);
      this.threeTimesADayInputTwo = setFrequencyTime(res?.frequency_times[1]);
      this.threeTimesADayInputThree = setFrequencyTime(res?.frequency_times[2]);
    }
  }

  onSearchChange() {
    this.currentPage = 1;
    this.getNotificationsCall();
  }
  onChangeEmailSettings(event: any) {
    if (event.target.id === "allEmailSubscribed") {
      this.allEmailSubscribed = event.target.checked;
      this.customEmailSubscribed = false;
    } else {
      this.allEmailSubscribed = false;
      this.customEmailSubscribed = event.target.checked;
    }
    if (!this.allEmailSubscribed && !this.customEmailSubscribed) {
      this.selectedFrequency = this.fifteenMinutesFrequency;
      this.resetTimeValidation();
    }
    this.customEmailOptions = this.customEmailOptions.map((option) => ({
      ...option,
      checked: false,
    }));
  }
  onChangeCustomEmailSettings(event: any) {
    this.customEmailOptions = this.state.getSavedFilters().map((filter) => {
      const foundEvent = event.find((e: any) => e.value === filter.id);
      if (foundEvent) {
        return {
          label: filter.name,
          value: filter.id,
          checked: foundEvent.checked,
        };
      }
      return { label: filter.name, value: filter.id, checked: false };
    });
  }
  onSaveEmailSettings() {
    let frequencyValues: string[] = this.setFrequencyValuesForEmailSettings();

    if (this.alertFrequencyForm.valid) {
      const body = {
        emails_enabled: this.allEmailSubscribed || false,
        is_customized: this.customEmailSubscribed || false,
        email_frequency: this.selectedFrequency,
        frequency_times: frequencyValues,
        filter_ids: this.customEmailOptions
          ?.map((option) => {
            if (option.checked) {
              return option.value;
            }
          })
          .filter((option) => option),
      };
      if (body.is_customized && body.filter_ids.length === 0) {
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: "Please select at least one filter.",
        });
        return;
      }
      this.isSavingSettings = true;
      this.notificationService.updateUserSettings(body).subscribe({
        next: (res) => {
          this.getEmailSettingsCall();
          this.sidebarVisible2 = false;
          this.isSavingSettings = false;
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Email settings updated",
          });
        },
        error: (err) => {
          this.isLoadingSettings = false;
        },
      });
    } else {
      this.alertFrequencyForm.control.markAllAsTouched();
    }
  }

  setFrequencyValuesForEmailSettings() {
    let frequencyValues: string[] = [];

    if (this.selectedFrequency == "onceADay") {
      frequencyValues = [
        this.validateTimeInput(
          "onceADay",
          this.frequencyFields.onceADayTimeInput
        ),
      ];
    }
    if (this.selectedFrequency == "twiceADay") {
      frequencyValues = [
        this.validateTimeInput(
          "twiceADayInputOne",
          this.frequencyFields.twiceADayInputOne
        ),
        this.validateTimeInput(
          "twiceADayInputTwo",
          this.frequencyFields.twiceADayInputTwo
        ),
      ];
    }
    if (this.selectedFrequency == "threeTimesADay") {
      frequencyValues = [
        this.validateTimeInput(
          "threeTimesADayInputOne",
          this.frequencyFields.threeTimesADayInputOne
        ),
        this.validateTimeInput(
          "threeTimesADayInputTwo",
          this.frequencyFields.threeTimesADayInputTwo
        ),
        this.validateTimeInput(
          "threeTimesADayInputThree",
          this.frequencyFields.threeTimesADayInputThree
        ),
      ];
    }

    return frequencyValues;
  }
  onCloseEmailSettings() {
    this.customEmailOptions = this.state.getSavedFilters().map((filter) => ({
      label: filter.name,
      value: filter.id,
    }));
    this.getEmailSettingsCall();
    this.sidebarVisible2 = false;
  }
  onTabChangeHandler(selectedTab: any) {
    this.selectAllNotificationsForMultiSelect = false;
    this.selectedNotifications = [];
    this.showDefaultPage = true;
    this.currentPage = 1;
    this.selectedTab = selectedTab;
    this.getNotificationsCall();
  }
  onSortHandler(sort: string) {
    this.currentPage = 1;
    if (this.currentSort === sort) {
      this.sortBy = "";
      this.hasComments = false;
      this.hasUnread = false;
      this.currentSort = "";
      this.getNotificationsCall();
      return;
    }
    this.currentSort = sort;

    switch (sort) {
      case "Newest":
      case "Oldest":
        this.sortBy = sort;
        this.hasComments = false;
        this.hasUnread = false;
        break;
      case "comments":
        this.sortBy = "";
        this.hasComments = true;
        this.hasUnread = false;
        break;
      case "unread":
        this.sortBy = "";
        this.hasComments = false;
        this.hasUnread = true;
        break;
      default:
        this.sortBy = "";
        this.hasComments = false;
        this.hasUnread = false;
        break;
    }
    this.getNotificationsCall();
  }
  getNotificationPayload() {
    let body = {
      pageSize: this.rowsPerPage,
      pageNo: this.currentPage,
      status: this.selectedTab,
    } as any;
    if (this.sortBy) {
      body.sort = this.sortBy === "Newest" ? "DESC" : "ASC";
    } else if (this.hasComments) {
      body.onlyWithComments = this.hasComments;
    } else if (this.hasUnread) {
      body.onlyUnRead = this.hasUnread;
    }
    let panelsSelected = [];
    if (this.selectedPanels?.length > 0) {
      panelsSelected = this.selectedPanels.map((panel) =>
        panel.replace("panel-", "")
      );
      body.panels = panelsSelected;
    }
    if (this.appliedFilters?.length > 0) {
      body = this.handlePanelSelectionFromHomeDropdown(
        body,
        panelsSelected,
        this.appliedFilters
      );
    }
    if (this.search) {
      body.search = this.search;
    }
    return body;
  }

  handlePanelSelectionFromHomeDropdown(
    body: any,
    panelsSelectedFromHomeDropdown: any,
    filterValues: any
  ) {
    const filterValuesTemp = JSON.parse(JSON.stringify(filterValues));
    for (let i = filterValuesTemp.length - 1; i >= 0; i--) {
      const filterValue = filterValuesTemp[i];
      if (filterValue?.key == "panel") {
        if (panelsSelectedFromHomeDropdown?.length == 0) {
          filterValuesTemp?.splice(i, 1);
        } else {
          filterValue.value = panelsSelectedFromHomeDropdown.join();
        }
      }
    }

    if (filterValuesTemp?.length > 0) {
      body.filters = filterValuesTemp;
    }

    return body;
  }

  getNotificationsCall() {
    this.searchNotificationsInSelectedPanel.next(this.getNotificationPayload());
    this.isLoadingNotifications = true;
  }

  checkIfSelectedNotificationIsPresentInList(notifications: any) {
    if (!this.selectedNotification) return;

    const selectedNotificationPresentInList = notifications.data.find(
      (notification: INotification) => {
        return notification.id == this.selectedNotification.id;
      }
    );

    if (!selectedNotificationPresentInList) {
      this.selectedNotification = "";
    }
  }

  setSelectedNotification(index: any) {
    this.selectedNotification = this.notifications[index];
  }

  filtersVisible = false;
  openFilters() {
    this.filtersVisible = true;
  }
  closeFilters() {
    this.filtersVisible = false;
  }
  openSettingsDrawer() {
    this.isLoadingSettings = true;
    this.filterService.getAllSavedFilters().subscribe({
      next: (data) => {
        this.state.setSavedFilters(data);
        this.customEmailOptions = data.map((filter) => ({
          label: filter.name,
          value: filter.id,
        }));
        this.getEmailSettingsCall();
      },
      error: (err) => {
        console.error("Error while subscribing:");
      },
    });
    this.sidebarVisible2 = true;
  }
  handleAppliedFilters(appliedFilterCount: number) {
    this.appliedFilterCount = appliedFilterCount;
  }

  onNotificationSelect(notification: INotification) {
    this.selectedNotification = notification;
    this.showDefaultPage = false;
  }

  setIntervalForUserActivity() {
    this.userActivityInterval = setInterval(() => {
      if (
        this.lastActivityTime &&
        new Date().getTime() - this.lastActivityTime.getTime() <=
          USER_ACTIVITY_MESSAGE_INTERVAL
      ) {
        window.parent.postMessage({ type: "UUX-Activity" }, "*");
      }
    }, USER_ACTIVITY_MESSAGE_INTERVAL);
  }

  showNoPanelsWarning() {
    this.messageService.add({
      severity: "error",
      summary: "Error",
      detail:
        "You are not assigned any panels. Please contact your MX Administrator or MX Support",
      sticky: true,
    });
    this.setIntervalForUserActivity();
  }

  handleInitialToken(data: any) {
    const token = data["accessToken"];
    this.state.setUser({
      ...this.state.getUser(),
      email: decodeToken(token)?.username,
    });
    const tokenPayload = decodeToken(token);
    const iss = tokenPayload["iss"];
    const panelsList = tokenPayload["cognito:groups"];
    const panelsPresent =
      panelsList?.filter((panel: any) => panel.startsWith("panel-")).length > 0;
    this.messageService.clear();
    if (!panelsPresent) {
      return this.showNoPanelsWarning();
    }
    const parts = iss.split("/");
    const region =
      parts?.[2]?.split(".")?.[1] && parts?.[2]?.split(".")?.[1] !== "null"
        ? parts[2].split(".")[1]
        : "southeast-1";
    const userPoolId =
      parts?.[3] && parts[3] !== "null" ? parts[3] : "ap-southeast-1_ezYBJeap6";
    const organizationName =
      data["organizationName"] && data["organizationName"] !== "null"
        ? data["organizationName"]
        : "mx-dev-v3";
    const uuxSessionId =
      data["uuxSessionId"] && data["uuxSessionId"] !== "null"
        ? data["uuxSessionId"]
        : 1234;
    if (token) {
      this.state.setAccessToken(token);
      this.state.setMXRequestHeaderFields({
        region,
        "uux-session-id": uuxSessionId,
        organization: organizationName,
        pool_id: userPoolId,
      });
      this.headerData = {
        token: true,
        region,
        "uux-session-id": uuxSessionId,
        organization: organizationName,
        pool_id: userPoolId,
      };
      const body = {
        pageSize: 10,
        pageNo: 1,
        status: "all",
      } as any;
      this.isLoadingNotifications = true;

      this.filterService.getDefaultFilter().subscribe({
        next: (filter) => {
          if (filter) {
            this.defaultFilterId = filter.id;
            this.appliedFilter = filter;
            const filterValues = filter.filterValues;
            const cleanedFilterValues = filterValues.map((filterValue: any) => {
              return {
                key: filterValue.key,
                value: filterValue.value,
                operation: filterValue.operation,
                multi: filterValue.multi,
              };
            });

            const panelFilter = cleanedFilterValues?.find((filter: any) => {
              return filter.key == filterKeys.PANEL;
            });

            if (panelFilter) {
              const selectedPanels = panelFilter.value.split(",");
              this.notificationSharedService.updatedSelectedPanelsOnHome(
                selectedPanels
              );
            }

            body.filters = cleanedFilterValues;
          }

          this.getNotifications(body);
        },
        error: (err) => {
          this.getNotifications(body);
        },
      });

      this.setIntervalForUserActivity();
    }
  }

  getNotifications(body: any) {
    return this.notificationService.getNotifications(body).subscribe({
      next: (notifications) => {
        if (notifications?.data?.length > 0) {
          if (
            notifications.notificationComments &&
            notifications.notificationComments.length > 0
          ) {
            notifications.data = this.setComments(
              notifications.data,
              notifications.notificationComments
            );
          }
          this.state.setNotifications(notifications.data);
          this.state.setNotificationCountByStatus(
            getFormatedCountByStatus(notifications.metaData)
          );
          this.notificationCountByStatus =
            this.state.getNotificationCountByStatus();
          this.totalNotifications =
            notifications?.metaData?.totalFilteredCount || 0;
          this.notificationsinList = notifications?.data?.length || 0;
          this.notifications = notifications.data;
        }
        this.isLoadingNotifications = false;
        this.getPanels();
        this.getFilters();
      },
      error: (err) => {
        this.isLoadingNotifications = false;
      },
    });
  }

  notificationRemovedUpdateStats(stats: any) {
    const totalPages = getTotalPages(this.totalNotifications, this.rowsPerPage);

    this.totalNotifications = stats.totalNotifications;
    this.notificationsinList = stats.notificationsinList;

    if (
      this.notificationsinList == 0 &&
      this.currentPage > 1 &&
      this.currentPage == totalPages
    ) {
      this.currentPage = this.currentPage - 1;
      this.getNotificationsCall();
    }
  }

  getPanels() {
    return this.notificationService
      .getPanels()
      .pipe(take(1))
      .subscribe((data) => {
        if (this.selectedPanelsTemp?.length > 0) {
          this.selectedPanels = this.selectedPanelsTemp;
          this.selectedPanelsTemp = [];
        }

        this.panels = data
          ?.map((p: Panel) => {
            return {
              label:
                p?.display_name ||
                p?.panel_name?.replaceAll("_", " ") ||
                p?.panel?.replace("panel-", "")?.replaceAll("_", " "),
              value: p?.panel_name || p?.panel?.replace("panel-", ""),
            };
          })
          .sort((a: any, b: any) => a?.label?.localeCompare(b?.label));
      });
  }

  getFilters() {
    return this.filterService.getAllSavedFilters().subscribe({
      next: (data) => {
        this.state.setSavedFilters(data); // Assigns the fetched filters to a component variable
        this.customEmailOptions = data.map((filter) => ({
          label: filter.name,
          value: filter.id,
        }));
        this.getEmailSettingsCall();
      },
      error: (err) => {},
    });
  }

  handleTokenRefresh(data: any) {
    const token = data["accessToken"];
    this.state.setUser({
      ...this.state.getUser(),
      email: decodeToken(token)?.username,
    });

    const tokenPayload = decodeToken(token);
    const iss = tokenPayload["iss"];
    const panelsList = tokenPayload["cognito:groups"];
    const panelsPresent =
      panelsList.filter((panel: any) => panel.startsWith("panel-")).length > 0;
    this.messageService.clear();
    if (!panelsPresent) {
      return this.showNoPanelsWarning();
    }
    this.notificationService
      .getPanels()
      .pipe(take(1))
      .subscribe((data) => {
        this.panels = data
          ?.map((p: Panel) => {
            return {
              label:
                p?.display_name ||
                p?.panel_name?.replaceAll("_", " ") ||
                p?.panel?.replace("panel-", "")?.replaceAll("_", " "),
              value: p?.panel_name || p?.panel?.replace("panel-", ""),
            };
          })
          .sort((a: any, b: any) => a?.label?.localeCompare(b?.label));
      });

    const parts = iss.split("/");
    const region =
      parts?.[2]?.split(".")?.[1] && parts?.[2]?.split(".")?.[1] !== "null"
        ? parts[2].split(".")[1]
        : "southeast-1";
    const userPoolId =
      parts[3] && parts[3] !== "null" ? parts[3] : "ap-southeast-1_ezYBJeap6";
    if (token) {
      this.state.setAccessToken(token);
      this.state.setMXRequestHeaderFields({
        region,
        pool_id: userPoolId,
      });
      this.headerData = {
        ...this.headerData,
        token: true,
        region,
        pool_id: userPoolId,
      };
    }
  }

  handleLogout() {
    // Fire the logout request first (keepalive fetch — see notification
    // service) so it's in flight before state.logout() posts UUX-Logout
    // to the parent and the iframe gets killed. Cleanup then runs
    // synchronously since there's no response to wait on.
    this.notificationService.logout();
    this.headerData = null;
    clearInterval(this.userActivityInterval);
    this.userActivityInterval = null;
    this.state.logout();
  }

  handleMessage(event: MessageEvent) {
    // if (
    //   event.origin.includes("http://localhost:4200") ||
    //   event.origin.includes("https://mx-dev-wrapper.stella-apps.com")
    // ) {
    if (event?.data?.type) {
      switch (event.data.type) {
        case "UUX-Login":
          this.handleInitialToken(event.data);
          break;
        case "UUX-Refresh":
          this.handleTokenRefresh(event.data);
          break;
        case "UUX-Logout":
          this.handleLogout();
          break;

        default:
          break;
      }
    }
    // }
  }

  selectedCategories: any[] = [];

  categories: any[] = [
    { name: "Accounting", key: "A" },
    { name: "Marketing", key: "M" },
    { name: "Production", key: "P" },
    { name: "Research", key: "R" },
  ];
  notificationDetail: any = {};

  handleApplyFilters(filters: Filter[]) {
    this.currentPage = 1;
    this.appliedFilters = filters;
    this.appliedFilterCount = filters.length;
    this.selectedNotifications = [];
    this.selectAllNotificationsForMultiSelect = false;
    this.notificationListComponent.resetNotificationListInteractivity();
    this.notificationDetailComponent.resetNotificationDetailInteractivity();
    this.getNotificationsCall();
  }
  scrollToComments() {
    this.notificationDetailComponent.scrollToComments();
  }
  handleStatusChange(event: {
    notificationId: string;
    status: string;
    previousStatus: string;
  }) {
    if (this.notifications) {
      this.notifications = [
        ...this.notifications.map((notification) => {
          if (notification.id === event.notificationId) {
            return { ...notification, status: event.status };
          } else {
            return { ...notification };
          }
        }),
      ];
    }
    this.notificationCountByStatus[event.status] =
      this.notificationCountByStatus[event.status] + 1;

    if (this.notificationCountByStatus[event.previousStatus] > 0) {
      this.notificationCountByStatus[event.previousStatus] =
        this.notificationCountByStatus[event.previousStatus] - 1;
    }
  }

  handleStatusChangeForMultiple(event: {
    notificationIds: string[];
    status: string;
  }) {
    if (this.notifications) {
      this.notifications = [
        ...this.notifications.map((notification) => {
          let previousStatus = notification.status;
          const isUpdated = event.notificationIds.includes(notification.id);

          if (isUpdated) {
            this.notificationCountByStatus[event.status] =
              this.notificationCountByStatus[event.status] + 1;

            if (this.notificationCountByStatus[previousStatus] > 0) {
              this.notificationCountByStatus[previousStatus] =
                this.notificationCountByStatus[previousStatus] - 1;
            }
          }
          return isUpdated
            ? { ...notification, status: event.status }
            : { ...notification };
        }),
      ];
    }
  }

  handleDownloadNotification(notificationType: string) {
    let body = this.getNotificationPayload();
    if (notificationType) {
      body.notificationType = notificationType;
    }
    delete body.pageNo;
    delete body.pageSize;

    body = {
      ...body,
      sort: body.sort ?? "DESC",
      panels: body.panels ?? this.panels.map((panel) => panel.value),
      onlyUnRead: body.onlyUnRead || false,
      onlyWithComments: body.onlyWithComments || false,
      filters: body.filters ?? [],
    };
    this.messageService.add({
      severity: "info",
      summary: "Downloading",
      detail: `Downloading ${notificationType || ""} notifications`,
    });
    this.notificationService.downloadNotification(body).subscribe({
      next: (res) => {
        const blob = new Blob([res], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = `${notificationType}-Notifications.csv`;
        anchor.click();
        window.URL.revokeObjectURL(url);
        this.messageService.add({
          severity: "success",
          summary: "Success",
          detail: "Notifications downloaded successfully",
        });
      },
      error: (err) => {},
    });
  }

  handleListRefresh() {
    this.getNotificationsCall();
  }
  updateOpenedNotification(event: any) {
    this.notificationCountByStatus[event.status] =
      parseInt(this.notificationCountByStatus[event.status]) + 1;

    if (this.notificationCountByStatus[event.previousStatus] > 0) {
      this.notificationCountByStatus[event.previousStatus] =
        parseInt(this.notificationCountByStatus[event.previousStatus]) - 1;
    }

    if (
      this.selectedNotification &&
      this.selectedNotification.id === event.id
    ) {
      this.selectedNotification = {
        ...this.selectedNotification,
        status: event.status,
      };
    }
  }
  onClearSearch() {
    this.search = "";
    this.currentPage = 1;
    this.getNotificationsCall();
  }
  addCommentInNotification(event: any) {
    if (this.notifications) {
      this.notifications = [
        ...this.notifications?.map((notification) => {
          if (notification.id === event?.notificationId && event?.comment) {
            const comments =
              notification.comments.length === 5
                ? [event.comment, ...notification.comments.slice(0, 4)]
                : [event.comment, ...notification.comments];

            return { ...notification, comments };
          } else {
            return { ...notification };
          }
        }),
      ];
    }
  }
  deleteCommentInNotification(event: any) {
    if (this.notifications) {
      this.notifications = [
        ...this.notifications?.map((notification) => {
          if (notification.id === event?.notificationId) {
            return {
              ...notification,
              comments: [],
            };
          } else {
            return { ...notification };
          }
        }),
      ];
    }
  }

  handleSelectedNotifications(notifications: {
    selectedNotifications: string[];
    selectAllNotificationsForMultiSelect: boolean;
  }) {
    this.selectedNotifications = notifications.selectedNotifications;
    this.selectAllNotificationsForMultiSelect =
      notifications.selectAllNotificationsForMultiSelect;
    this.currentPageSettings = this.getNotificationPayload();
  }

  clearSelectedNotifications(selectedNotifications: string[]) {
    this.selectAllNotificationsForMultiSelect = false;
    this.selectedNotifications = selectedNotifications;
    this.showDefaultPage = true;
  }

  selectAllNotificationsOnCurrentPage() {
    const notificationIds = this.notifications.map(
      (notification: INotification) => {
        return notification.id;
      }
    );

    this.selectAllNotificationsForMultiSelect = false;
    this.selectedNotifications = Array.from(
      new Set([...this.selectedNotifications, ...notificationIds])
    );
  }

  selectAllNotificationsInboxPages() {
    const notificationIds = this.notifications.map(
      (notification: INotification) => {
        return notification.id;
      }
    );

    this.selectAllNotificationsForMultiSelect = true;
    this.selectedNotifications = notificationIds;
  }

  handleMarkReadUnreadChangeEventForMultiple(event: {
    notificationIds: string[];
    markReadUnread: string;
  }) {
    const notification_reads =
      event.markReadUnread == "true"
        ? [{ read_at: "", created_at: "", updated_at: "", id: "" }]
        : [];

    if (this.notifications) {
      this.notifications = [
        ...this.notifications.map((notification) => {
          const isUpdated = event.notificationIds.includes(notification.id);

          return isUpdated
            ? { ...notification, notification_reads: notification_reads }
            : { ...notification };
        }),
      ];
    }
  }

  handleStatusChangeForAll(event: any) {
    if (this.notifications) {
      this.notifications = [
        ...this.notifications.map((notification) => {
          let previousStatus = notification.status;

          this.notificationCountByStatus[event.status] =
            this.notificationCountByStatus[event.status] + 1;

          if (this.notificationCountByStatus[previousStatus] > 0) {
            this.notificationCountByStatus[previousStatus] =
              this.notificationCountByStatus[previousStatus] - 1;
          }
          return { ...notification, status: event.status };
        }),
      ];
    }
  }

  handleMarkReadUnreadChangeEventForAll(event: any) {
    const notification_reads =
      event.markReadUnread == "true"
        ? [{ read_at: "", created_at: "", updated_at: "", id: "" }]
        : [];

    if (this.notifications) {
      this.notifications = [
        ...this.notifications.map((notification) => {
          return { ...notification, notification_reads: notification_reads };
        }),
      ];
    }
  }

  handleRemovedChangeEventForMultiple(event: {
    notificationIds: string[];
    currentPageSettings: any;
  }) {
    this.isLoadingNotifications = true;
    const totalPages = getTotalPages(this.totalNotifications, this.rowsPerPage);
    if (this.notifications) {
      this.notifications = this.notifications.filter((notification) => {
        if (!event.notificationIds.includes(notification.id)) {
          return true;
        }
        this.notificationCountByStatus["all"] =
          this.notificationCountByStatus?.["all"] - 1;
        this.notificationCountByStatus[notification.status] =
          this.notificationCountByStatus?.[notification.status] - 1;
        this.totalNotifications = this.totalNotifications - 1;
        this.notificationsinList = this.notificationsinList - 1;

        return false;
      });
    }
    this.showDefaultPage = true;
    this.selectedNotifications = [];

    if (
      this.notifications?.length == 0 &&
      event.currentPageSettings?.pageNo > 1 &&
      event.currentPageSettings?.pageNo == totalPages
    ) {
      event.currentPageSettings.pageNo = event.currentPageSettings?.pageNo - 1;
      this.currentPage = event.currentPageSettings?.pageNo;
    }

    this.getNotifications(event.currentPageSettings);
  }

  handleRemovedChangeEventForAllNotifications() {
    this.selectedNotifications = [];
    this.totalNotifications = 0;
    this.notificationsinList = 0;

    if (this.selectedTab != "all") {
      this.getNotificationsCall();
    } else {
      this.notifications = [];
      this.notificationCountByStatus["all"] = 0;
      this.notificationCountByStatus["not-started"] = 0;
      this.notificationCountByStatus["in-progress"] = 0;
      this.notificationCountByStatus["completed"] = 0;
    }
    this.showDefaultPage = true;
  }

  updateNotificationCounterOnSingleRemove() {
    this.totalNotifications = this.totalNotifications - 1;
  }

  resetTimeValidation() {
    this.onceADayTimeInput = "";
    this.errorOnceADayInput = false;
    this.twiceADayInputOne = "";
    this.twiceADayInputTwo = "";
    this.errorTwiceADayInputOne = false;
    this.errorTwiceADayInputTwo = false;
    this.threeTimesADayInputOne = "";
    this.threeTimesADayInputTwo = "";
    this.threeTimesADayInputThree = "";
    this.errorThreeTimesADayInputOne = false;
    this.errorThreeTimesADayInputTwo = false;
    this.errorThreeTimesADayInputThree = false;
    this.frequencyFields.onceADayTimeInput = "";
    this.frequencyFields.twiceADayInputOne = "";
    this.frequencyFields.twiceADayInputTwo = "";
    this.frequencyFields.threeTimesADayInputOne = "";
    this.frequencyFields.threeTimesADayInputTwo = "";
    this.frequencyFields.threeTimesADayInputThree = "";
    this.frequencyErrorFields.errorOnceADayInput = false;
    this.frequencyErrorFields.errorTwiceADayInputOne = false;
    this.frequencyErrorFields.errorTwiceADayInputTwo = false;
    this.frequencyErrorFields.errorThreeTimesADayInputOne = false;
    this.frequencyErrorFields.errorThreeTimesADayInputTwo = false;
    this.frequencyErrorFields.errorThreeTimesADayInputThree = false;
  }

  frequencyFieldControls = {
    onceADayInput: null,
    twiceADayOne: null,
    twiceADayTwo: null,
    threeTimesADayOne: null,
    threeTimesADayTwo: null,
    threeTimesADayThree: null,
  };
  raiseInvalidFrequencyFlag(
    fieldName:
      | "onceADay"
      | "twiceADayInputOne"
      | "twiceADayInputTwo"
      | "threeTimesADayInputOne"
      | "threeTimesADayInputTwo"
      | "threeTimesADayInputThree"
  ) {
    this.setFrequencyInputFieldErrors(fieldName);
    this.frequencyFieldControls = raiseInvalidFrequencyFlag(
      fieldName,
      this.frequencyFieldControls
    );

    this.onceADayInput.control.setErrors({
      pattern: this.frequencyFieldControls.onceADayInput,
    });
    this.twiceADayOne.control.setErrors({
      pattern: this.frequencyFieldControls.twiceADayOne,
    });
    this.twiceADayTwo.control.setErrors({
      pattern: this.frequencyFieldControls.twiceADayTwo,
    });
    this.threeTimesADayOne.control.setErrors({
      pattern: this.frequencyFieldControls.threeTimesADayOne,
    });
    this.threeTimesADayTwo.control.setErrors({
      pattern: this.frequencyFieldControls.threeTimesADayTwo,
    });
    this.threeTimesADayThree.control.setErrors({
      pattern: this.frequencyFieldControls.threeTimesADayThree,
    });
  }

  frequencyErrorFields = {
    errorOnceADayInput: false,
    errorTwiceADayInputOne: false,
    errorTwiceADayInputTwo: false,
    errorThreeTimesADayInputOne: false,
    errorThreeTimesADayInputTwo: false,
    errorThreeTimesADayInputThree: false,
  };

  setFrequencyInputFieldErrors(fieldName: any) {
    this.frequencyErrorFields = setFrequencyInputFieldErrors(
      fieldName,
      this.frequencyErrorFields
    );
    this.errorOnceADayInput = this.frequencyErrorFields.errorOnceADayInput;
    this.errorTwiceADayInputOne =
      this.frequencyErrorFields.errorTwiceADayInputOne;
    this.errorTwiceADayInputTwo =
      this.frequencyErrorFields.errorTwiceADayInputTwo;
    this.errorThreeTimesADayInputOne =
      this.frequencyErrorFields.errorThreeTimesADayInputOne;
    this.errorThreeTimesADayInputTwo =
      this.frequencyErrorFields.errorThreeTimesADayInputTwo;
    this.errorThreeTimesADayInputThree =
      this.frequencyErrorFields.errorThreeTimesADayInputThree;
  }

  processTimeInput(
    event: any,
    fieldName:
      | "onceADay"
      | "twiceADayInputOne"
      | "twiceADayInputTwo"
      | "threeTimesADayInputOne"
      | "threeTimesADayInputTwo"
      | "threeTimesADayInputThree"
  ): void {
    if (!fieldName) {
      return;
    }

    const hours = event.getHours();
    const minutes = event.getMinutes();
    let value = formatTimeTwentyFourHour(hours, minutes);

    this.setFrequencyValues(fieldName, value);
  }

  validateTimeInput(fieldName: any, value: any) {
    if (!value) {
      this.raiseInvalidFrequencyFlag(fieldName);
      return "";
    }

    const [hours, minutes] = value.split(":");
    const isValid =
      !isNaN(Number(hours)) &&
      !isNaN(Number(minutes)) &&
      minutes.toString().length == 2 &&
      +hours < 24 &&
      +minutes < 60;
    if (!isValid) {
      this.raiseInvalidFrequencyFlag(fieldName);
    } else {
      this.clearFrequencyInputFieldErrors(fieldName);
    }

    return value;
  }

  clearFrequencyInputFieldErrors(fieldName: any) {
    const {
      frequencyErrorFieldValues: frequencyErrorFieldValuesTemp,
      frequencyErrorFieldControls: frequencyErrorFieldControlsTemp,
    } = clearFrequencyInputFieldErrors(
      fieldName,
      this.frequencyErrorFields,
      this.frequencyFieldControls
    );
    this.frequencyErrorFields = frequencyErrorFieldValuesTemp;
    this.frequencyFieldControls = frequencyErrorFieldControlsTemp;

    this.errorOnceADayInput = this.frequencyErrorFields.errorOnceADayInput;
    this.errorTwiceADayInputOne =
      this.frequencyErrorFields.errorTwiceADayInputOne;
    this.errorTwiceADayInputTwo =
      this.frequencyErrorFields.errorTwiceADayInputTwo;
    this.errorThreeTimesADayInputOne =
      this.frequencyErrorFields.errorThreeTimesADayInputOne;
    this.errorThreeTimesADayInputTwo =
      this.frequencyErrorFields.errorThreeTimesADayInputTwo;
    this.errorThreeTimesADayInputThree =
      this.frequencyErrorFields.errorThreeTimesADayInputThree;

    this.onceADayInput.control.setErrors(
      this.frequencyFieldControls.onceADayInput
    );
    this.twiceADayOne.control.setErrors(
      this.frequencyFieldControls.twiceADayOne
    );
    this.twiceADayTwo.control.setErrors(
      this.frequencyFieldControls.twiceADayTwo
    );
    this.threeTimesADayOne.control.setErrors(
      this.frequencyFieldControls.threeTimesADayOne
    );
    this.threeTimesADayTwo.control.setErrors(
      this.frequencyFieldControls.threeTimesADayTwo
    );
    this.threeTimesADayThree.control.setErrors(
      this.frequencyFieldControls.threeTimesADayThree
    );
  }

  frequencyFields: any = {};
  setFrequencyValues(frequencyName: any, value: any) {
    this.frequencyFields = setFrequencyValues(
      frequencyName,
      value,
      this.frequencyFields
    );
  }

  updateFrequencyHtmlFields(frequencyName: any, value: any) {
    if (frequencyName == "onceADay") {
      this.onceADayTimeInput = value;
    } else if (frequencyName == "twiceADayInputOne") {
      this.twiceADayInputOne = value;
    } else if (frequencyName == "twiceADayInputTwo") {
      this.twiceADayInputTwo = value;
    } else if (frequencyName == "threeTimesADayInputOne") {
      this.threeTimesADayInputOne = value;
    } else if (frequencyName == "threeTimesADayInputTwo") {
      this.threeTimesADayInputTwo = value;
    } else if (frequencyName == "threeTimesADayInputThree") {
      this.threeTimesADayInputThree = value;
    }
  }

  getFrequencyValue(frequencyName: any) {
    if (frequencyName == "onceADay") {
      return this.onceADayTimeInput;
    } else if (frequencyName == "twiceADayInputOne") {
      return this.twiceADayInputOne;
    } else if (frequencyName == "twiceADayInputTwo") {
      return this.twiceADayInputTwo;
    } else if (frequencyName == "threeTimesADayInputOne") {
      return this.threeTimesADayInputOne;
    } else if (frequencyName == "threeTimesADayInputTwo") {
      return this.threeTimesADayInputTwo;
    } else if (frequencyName == "threeTimesADayInputThree") {
      return this.threeTimesADayInputThree;
    }
    return "";
  }

  setFrequencyInput(event: any, fieldName: any) {
    let target = event?.target;

    if (target) {
      const value = event?.target?.value?.replace(/[^0-9aApPmM]/g, "");
      let valueUpperCase = value?.toUpperCase();

      if (valueUpperCase) {
        let raw = valueUpperCase.replace(/[^0-9APM]/g, "");

        if (raw.length < 5 && /a|p|m|am|pm/i.test(raw)) {
          target.value = "";
        } else {
          const { result, hours, minutes, amPm } = validateFrequencyValue(raw);
          target.value = result;

          if (amPm) {
            let hoursInt = parseInt(hours);
            let minutesInt = parseInt(minutes);
            if (amPm === "PM" && hoursInt < 12) {
              hoursInt += 12;
            } else if (amPm === "AM" && hoursInt === 12) {
              hoursInt = 0;
            }

            const now = new Date();
            const pCalendarTime = new Date(
              now.getFullYear(),
              now.getMonth(),
              now.getDate(),
              hoursInt,
              minutesInt,
              0,
              0
            );

            const value = formatTimeTwentyFourHour(hoursInt, minutesInt);
            this.setFrequencyValues(fieldName, value);
            this.clearFrequencyInputFieldErrors(fieldName);
            this.updateFrequencyHtmlFields(fieldName, pCalendarTime);
          }
        }
      }
    }
  }

  validateKeyPressed(event: any) {
    const invalid =
      event?.target?.value?.length > 8 &&
      !["Backspace", "ArrowLeft", "ArrowRight"].includes(event?.key);

    if (invalid) {
      event.preventDefault();
    } else {
      let target = event?.target;
      if (target) {
        this.handleBackSpace(target, event?.key);
      }
    }
  }

  handleBackSpace(target: any, keyPressed: any) {
    const cursorPos = target.selectionStart ?? 0;
    let value = target.value;

    if (cursorPos > 0 && keyPressed == "Backspace") {
      if (cursorPos < 3) {
        value = value.slice(0, 2);
        target.value = value;
      } else if (cursorPos > 3 && cursorPos < 6) {
        value = value.slice(0, 3);
        target.value = value;
      } else {
        const charBeforeCursor = target.value[cursorPos - 1];

        if (charBeforeCursor.toString().toLowerCase() == "m") {
          value = value.replace(/am|pm|a|p|m/gi, "");
          target.value = value;
        }
        if (
          target.value.length == "3" &&
          charBeforeCursor.toString().toLowerCase() == ":"
        ) {
          value = value.replace(":", "");
          target.value = value;
        }
      }
    }
  }

  verifyEmptyInput(fieldName: any) {
    if (!this.getFrequencyValue(fieldName)) {
      this.setFrequencyValues(fieldName, null);
    }
  }

  setComments(notifications: any, notificationComments: any) {
    notifications = notifications.map((notification: any) => {
      notification.comments = notificationComments.filter(
        (comment: any) => comment.notification_id === notification.id
      );

      return notification;
    });

    return notifications;
  }
}
